import type { CorrectComponentType } from "/npm/@brytdesigns/web-component-utils@0.1.7";
import { getTemplateContent, type Format } from "/npm/@brytdesigns/shopify-hybrid-cart-components@0.2.19/dist/jsdelivr/utils/index.js";

import { Show, For, type Accessor } from "/npm/solid-js@^1.9.5/+esm";

import {
  type ValidHybridPath,
  useFullPropertyPath,
  useCartValue,
  provideFullPropertyPathContext,
} from "/npm/@brytdesigns/shopify-hybrid-cart-components@0.2.19/dist/jsdelivr/hooks/index.js";
import html from "/npm/solid-js@^1.9.5/html/+esm";

type CartDataArrayProps = {
  arrayPath: ValidHybridPath;
  format?: Format;
};

export const CartDataArray: CorrectComponentType<CartDataArrayProps> = (
  props,
  { element },
) => {
  const itemTemplate = getTemplateContent(element, "item");
  if (!itemTemplate)
    return console.warn(
      "cart-data-array: No template found with a property of 'item'.",
    );
  if (!props.arrayPath)
    return console.warn("cart-data-array: No array path provided.");
  const mergedProps = {
    element,
    path: () => props.arrayPath,
  };
  const fullPath = useFullPropertyPath(mergedProps);
  provideFullPropertyPathContext({
    element,
    path: fullPath,
  });

  const value = useCartValue({
    element,
    path: fullPath,
  });

  const arrayValue = () => {
    const v = value();

    if (!v) {
      console.warn(
        `cart-data-array: value is null or undefined at path ${fullPath()}`,
      );
      return null;
    }

    if (!Array.isArray(v)) {
      console.warn(
        `cart-data-array: value is not an array at path ${fullPath()}`,
      );
      return null;
    }

    return v;
  };

  return html`
    <${Show} when=${() => arrayValue() && arrayValue()!.length > 0}>
      <${For} each=${arrayValue}>
        ${(_: any, idx: Accessor<number>) => html`
          <cart-data-array-item item-index=${() => `${idx()}`}>
            ${() => Array.from(itemTemplate.cloneNode(true).childNodes)}
          </cart-data-array-item>
        `}
      <//>
    <//>
  `;
};
